import { injectable } from 'tsyringe'
import { UserApiRepository } from '@/app/repositories/api/UserApiRepository'
import { User, Export } from '@/domain/entities/User'
import {
  PostUserInterface,
  DeleteUserInterface,
  UpdateUserInterface,
  PostImportFile,
} from '@/data/payload/contracts/UserRequest'
@injectable()
export class HomePresenter {
  private repository: UserApiRepository

  constructor(repository: UserApiRepository) {
    this.repository = repository
  }

  public loadUser(params: Object): Promise<User> {
    return this.repository.getAll(params)
  }

  public loadExport(params: Object): Promise<Export> {
    return this.repository.getExport(params)
  }

  public postUser(payload: PostUserInterface): Promise<User> {
    return this.repository.post(payload)
  }

  public postImport(payload: PostImportFile): Promise<User> {
    return this.repository.postImport(payload)
  }

  public updateUser(payload: UpdateUserInterface, id: number): Promise<User> {
    return this.repository.update(payload, id)
  }
  public updateUserDnet(payload: UpdateUserInterface): Promise<User> {
    return this.repository.updateDnet(payload)
  }

  public deleteUser(payload: DeleteUserInterface): Promise<User> {
    return this.repository.delete(payload)
  }
}
